import { useMemo, useLayoutEffect } from "react";
import useCalendarStore from "@/store/calendar-store";
import BaseCalendarView from "../shared/base-calendar-view";
import { useClientEvents } from "../../../../hooks/use-client-events";
import { useViewStore } from "../../../../store/view-store";
import { useAuthStore } from "../../../../store/auth-store";
import { useWaitlistJoin } from "../../../../hooks/use-waitlist-join";

const ClientCalendar = () => {
  const layout = useMemo(() => {
    if (typeof window === "undefined") {
      return null;
    }

    return new URLSearchParams(window.location.search).get("layout");
  }, []);

  const { isAuthenticated } = useAuthStore();

  const { data, isLoading } = useClientEvents();
  const { setIsMobile, setView } = useCalendarStore();

  const { setSelectedEvent } = useViewStore();

  // Use layout effect to set up the mobile detection and view immediately
  useLayoutEffect(() => {
    const handleResize = () => {
      if (layout === "agenda") {
        setIsMobile(false);
        setView("agenda");
        return;
      }

      const isMobile = window.innerWidth < 768;
      setIsMobile(isMobile);
      setView(isMobile ? "day" : "week");
    };

    // Run once immediately to avoid flash
    handleResize();

    // Set up resize handler
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [layout, setIsMobile, setView]);

  const { joinWaitlist } = useWaitlistJoin();

  const handleEventClick = (event: any) => {
    setSelectedEvent(event, isAuthenticated);
  };

  const handleWaitlistJoin = (event: any) => {
    if (!isAuthenticated) {
      setSelectedEvent(event, false); // go to login
      return;
    }
    joinWaitlist(event.id);
  };

  return (
    <section className="w-full bg-muted/30 p-4" id="calendar">
      <div className="max-w-7xl mx-auto">
        <BaseCalendarView
          classSessions={data || []}
          onEventClick={handleEventClick}
          onWaitlistJoin={handleWaitlistJoin}
          isLoading={isLoading}
        />
      </div>
    </section>
  );
};

// Export as memoized component to prevent unnecessary re-renders
export default ClientCalendar;
